import React, { createContext, useContext, useState, useCallback } from "react"

const EmotionFilterContext = createContext(null)

export function EmotionFilterProvider({ children }) {
  const [emotion, setEmotionState] = useState(null)

  // clicking the same emotion again clears the filter
  const setEmotion = useCallback((e) => {
    setEmotionState((prev) => (prev === e ? null : e))
  }, [])

  const clear = useCallback(() => setEmotionState(null), [])

  return (
    <EmotionFilterContext.Provider value={{ emotion, setEmotion, clear }}>
      {children}
    </EmotionFilterContext.Provider>
  )
}

export function useEmotionFilter() {
  const ctx = useContext(EmotionFilterContext)
  if (!ctx) throw new Error("useEmotionFilter must be used within an EmotionFilterProvider")
  return ctx
}
